import React from 'react'
import Button from 'antd/lib/button'
import classNames from 'classnames'
import _JSXStyle from 'styled-jsx/style'
import ImageWithBasePath from '../components/ImageWithBasePath'
export const AdvertiserPrimaryButton = ({
  id = '',
  title,
  onClick = () => {},
  disabled = false,
  loading = false,
  extraClassName = 'bg-secondary',
  isArrowPresent = true,
  containerClassName = '',
  isCsat = false,
  isb2b = false,
  isb2btestmonial = false,
  isCPMFlow = false,
  isCPMFlowMedium = false,
  ...rest
}) => (
  <div
    id={id}
    direction="vertical"
    style={{
      width: '100%',

      position: 'relative'
    }}
    className={classNames(
      !isb2b && 'h-[44px] rounded-[3px]',
      containerClassName,
      isCPMFlow && 'rounded-[8px]'
    )}
  >
    <Button
      {...{
        disabled,
        onClick,
        loading,
        ...rest
      }}
      autoFocus={false}
      block
      className={classNames(
        'remove m-0 p-0 relative flex h-full w-full items-center justify-center gap-[0px] space-x-[4px] py-[11px] font-noto-sans text-md font-bold leading-[21.79px]  outline-none hover:border-[0px] hover:shadow-none focus:outline-none',
        extraClassName,
        isCsat ? 'h-[40px] rounded-[8px]' : 'h-[44px] rounded-[3px]',
        isb2b && 'h-[40px] rounded-[8px] py-[9px] text-[14px]',
        isb2btestmonial
          ? 'rounded-[8px] py-[9px] text-[18px] text-[#191919]'
          : isCPMFlow
          ? 'py-[10px] px-[24px] text-[#191919]'
          : ' text-[#333436]',
        isCPMFlow &&
          'h-[40px]  rounded-[8px] py-[10px] px-[24px] text-[14px] font-bold leading-[21px] text-[#191919]',
        isCPMFlowMedium &&
          'h-[30px]  rounded-[8px] py-xs px-[16px] text-[12px] font-bold leading-[21px] text-greyTitleBase900'
      )}
    >
      <div>{!loading ? title : ' '}</div>
      {isArrowPresent && !loading && (
        <div className="relative h-[16px] w-[16px]">
          <ImageWithBasePath src="recruiter_arrow_forward" fill alt="button forward arrow" />
        </div>
      )}
    </Button>
    <style jsx global>{`
      .ant-btn-default {
        border-width: 0px;
      }
      :where(.css-dev-only-do-not-override-1ij74fp).ant-btn-default {
        box-shadow: none;
      }
    `}</style>
  </div>
)
